module.exports = __webpack_public_path__ + "static/heart-51fd38e3f81dd09a6ecfb105359d9927.svg";